import React, {
  Fragment,
  createContext,
  useEffect,
  useLayoutEffect,
} from "react";
import styled from "styled-components";
import { Location } from "@reach/router";
import { View, Text, Divider, Link, A, Icon } from "./components";
import { useToggle } from "react-hooks-lib";
import ArtistsIndex, { Container as AgencyContainer } from "./ArtistsIndex";
import CloseIcon from "./components/CloseIcon";
import Logo from "./components/Logo";
import LogoSmall from "./components/LogoSmall";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

const ScrollLock = () => {
  useLayoutEffect(() => {
    const targetElement = window.document.querySelector("#overlay-menu");
    setTimeout(() => {
      disableBodyScroll(targetElement);
    }, 50);
    return () => clearAllBodyScrollLocks();
  }, []);
  return null;
};

const Container = styled(View).attrs(() => ({
  px: [4, 4, 5],
  bg: "#EEE",
}))`
  position: fixed;
  padding-top: calc(4vh + 4vw);
  padding-bottom: calc(4vh + 4vw);
  left: 0;
  width: calc(
    100vw - ${({ theme }) => theme.space[4]} - ${({ theme }) => theme.space[4]}
  );
  max-width: 280px;
  @media (max-width: 320px) {
    max-width: none;
  }
  top: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  opacity: 0;
  pointer-events: none;
  visibility: visible;
  ${(props) =>
    props.visible &&
    `
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
  `} transition: opacity 250ms ease;
  transform: translate3d(0, 0, 0);
  z-index: 998;
`;

const ColumnBlock = styled(View).attrs(() => ({ pr: 4 }))`
  display: inline-block;
  width: 100%;
`;

const Toggle = ({ location, on, toggle }) => {
  useEffect(() => {
    if (on) {
      toggle();
    }
  }, [location]);
  return null;
};

const OverlayMenu = ({ children, on, toggle }) => {
  return (
    <Fragment>
      <Location>
        {({ location }) => (
          <Toggle location={location} on={on} toggle={toggle} />
        )}
      </Location>
      <Container visible={on} id="overlay-menu">
        {on && <ScrollLock />}
        <View pt={3}>
          <View>
            <LogoSmall style={{ right: "auto", marginTop: 32 }} />

            <Link invert block to="/artists" mb={5} mt={6}>
              Artists
            </Link>

            <ArtistsIndex mobile />
            <Divider mt={120} />

            <Link invert to="/">
              News
            </Link>
            <Divider />

            <Link
              invert
              as="a"
              href="https://www.houseoforangeeducation.nl/"
              target="_blank"
            >
              Education
            </Link>
            <Divider />
            <Link invert to="/contact">
              Contact
            </Link>
            <Divider />
          </View>

          <View mt={120}>
            <Text mb={4} mt={6}>
              House of Orange
            </Text>
            <Text textStyle="bread">
              <p style={{ display: "none" }}>
                <Link
                  invert
                  as="a"
                  target="_blank"
                  href="https://maps.google.com/maps?daddr=Leidsegracht+6H,+1016+CK,+Amsterdam,+Netherlands"
                >
                  Leidsegracht 6H
                  <br />
                  1016 CK Amsterdam,
                  <br />
                  The Netherlands
                </Link>
              </p>
              <p>
                <Link invert as="a" href="mailto:info@houseoforange.nl">
                  info@houseoforange.nl
                </Link>
                <br />
                <Link invert as="a" href="tel:+31206223303">
                  +31 (0)20 622 3303
                </Link>
              </p>
              <View mt={4} mb={1}>
                <A
                  href="https://www.facebook.com/Houseoforange"
                  target="_blank"
                >
                  <Icon icon="facebook" mr={3} />
                </A>
                <A
                  href="https://www.instagram.com/houseoforangeagency"
                  target="_blank"
                >
                  <Icon icon="instagram" />
                </A>
              </View>
            </Text>
          </View>
        </View>
      </Container>
    </Fragment>
  );
};

export default OverlayMenu;
